export enum StorageKeys{
    Auth = 'tp_authnResult',
    DashboardClientInvoiceFilters = 'dashboardClientInvoiceFilters',
    ClientInvoiceFilters = 'clientInvoiceFilters',
    Language = 'language',
    LanguagePickedByUser = 'languagePickedByUser',
    Menu = 'menu',
    Theme = 'theme',
    Redirect = 'redirect',
}